import React from 'react';
import { SocialSigningForm as SocialSigningFormCore } from '@fiverr-private/identification_core';
import { useStepsContext } from '../StepsContext';

type SocialSigningFormCoreProps = React.ComponentProps<typeof SocialSigningFormCore>;

export const SocialSigningForm = () => {
    const { goToStep } = useStepsContext();

    const onEmailButtonClick: SocialSigningFormCoreProps['onEmailButtonClick'] = () => {
        goToStep('email_identification');
    };

    return (
        <SocialSigningFormCore
            onSocialFallback={() => goToStep('social_fallback')}
            onProfileSetup={() => goToStep('profile_setup')}
            onEmailButtonClick={onEmailButtonClick}
        />
    );
};
